class VersionController {
    constructor() {
      this.name = 'app-version';
    }
  }
  
export default VersionController;


// WEBPACK FOOTER //
// ./client/app/components/version/version.controller.js